import { Field, FieldInput, FieldLabel, FieldSelect, FieldTextarea } from '@ibe/ui';
import { Controller, type Control, type FieldErrors, type UseFormRegister } from 'react-hook-form';

import { PropertyMultiSelect } from '../../../components/form/property-multi-select.js';
import { type PropertyGroupFormInput } from '../api/schemas.js';

export function PropertyGroupFields({
  register,
  errors,
  control,
}: {
  readonly register: UseFormRegister<PropertyGroupFormInput>;
  readonly errors: FieldErrors<PropertyGroupFormInput>;
  readonly control: Control<PropertyGroupFormInput>;
}): React.JSX.Element {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field error={errors.code?.message} required>
          <FieldLabel>Code</FieldLabel>
          <FieldInput autoComplete="off" placeholder="CODE" {...register('code')} />
        </Field>
        <Field error={errors.name?.message} required>
          <FieldLabel>Name</FieldLabel>
          <FieldInput autoComplete="off" placeholder="Name" {...register('name')} />
        </Field>
      </div>
      <Field error={errors.description?.message}>
        <FieldLabel>Description</FieldLabel>
        <FieldTextarea {...register('description')} />
      </Field>
      <Controller
        control={control}
        name="status"
        render={({ field }) => (
          <Field error={errors.status?.message} required>
            <FieldLabel>Status</FieldLabel>
            <FieldSelect
              value={field.value}
              onValueChange={(value) => {
                field.onChange(value);
              }}
              options={[
                { value: 'ACTIVE', label: 'Active' },
                { value: 'INACTIVE', label: 'Inactive' },
              ]}
              placeholder="Select status…"
            />
          </Field>
        )}
      />
      <Controller
        control={control}
        name="propertyIds"
        render={({ field }) => (
          <PropertyMultiSelect
            value={field.value}
            onChange={(value) => {
              field.onChange(value);
            }}
            error={errors.propertyIds?.message}
          />
        )}
      />
    </div>
  );
}
